module.exports = __webpack_public_path__ + "static/logos-10-f8a4b6d256bebc380637ab4bcb34d3e4.png";